import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { EmployeeRelative } from '../entities/employee-relative';

@Injectable()
export class EmployeeRelativeService extends BaseCrudService<EmployeeRelative> {

  public uri = '/api/employeeRelative/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance EmployeeRelativeService');
  }

  buildSentence(entity?: EmployeeRelative, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.row ?
          `row${QueryOperator.Contain}${entity.row}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.firstLastName ?
          `firstLastName${QueryOperator.Contain}${entity.firstLastName}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.secondLastName ?
          `secondLastName${QueryOperator.Contain}${entity.secondLastName}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.name ?
          `name${QueryOperator.Contain}${entity.name}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.birthDate ?
          `birthDate${QueryOperator.Equal}${entity.birthDate}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.paternityDocumentNumber ?
          `paternityDocumentNumber${QueryOperator.Contain}${entity.paternityDocumentNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.documentNumber ?
          `documentNumber${QueryOperator.Contain}${entity.documentNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.conceptionMonth ?
          `conceptionMonth${QueryOperator.Contain}${entity.conceptionMonth}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.phone1 ?
          `phone1${QueryOperator.Contain}${entity.phone1}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.phone2 ?
          `phone2${QueryOperator.Contain}${entity.phone2}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isRightholder ?
          `isRightholder${QueryOperator.Equal}${entity.isRightholder}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.startDate ?
          `startDate${QueryOperator.Equal}${entity.startDate}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.endDate ?
          `endDate${QueryOperator.Equal}${entity.endDate}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.hasEps ?
          `hasEps${QueryOperator.Equal}${entity.hasEps}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.disabilityDocumentNumber ?
          `disabilityDocumentNumber${QueryOperator.Contain}${entity.disabilityDocumentNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.email ?
          `email${QueryOperator.Contain}${entity.email}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.comment ?
          `comment${QueryOperator.Contain}${entity.comment}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.subscriptionDate ?
          `subscriptionDate${QueryOperator.Equal}${entity.subscriptionDate}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.subscriptionNumber ?
          `subscriptionNumber${QueryOperator.Contain}${entity.subscriptionNumber}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.isStudent ?
          `isStudent${QueryOperator.Equal}${entity.isStudent}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      if (entity.documentType && entity.documentType.id) {
        query = query.concat(
          `documentType.id${QueryOperator.Equal}${entity.documentType.id}${QueryOperator.Split}`
        );
      }
      if (entity.employee && entity.employee.id) {
        query = query.concat(
          `employee.id${QueryOperator.Equal}${entity.employee.id}${QueryOperator.Split}`
        );
      }
      if (entity.relationshipType && entity.relationshipType.id) {
        query = query.concat(
          `relationshipType.id${QueryOperator.Equal}${entity.relationshipType.id}${QueryOperator.Split}`
        );
      }
      if (entity.sex && entity.sex.id) {
        query = query.concat(
          `sex.id${QueryOperator.Equal}${entity.sex.id}${QueryOperator.Split}`
        );
      }
      if (entity.paternityDocumentType && entity.paternityDocumentType.id) {
        query = query.concat(
          `paternityDocumentType.id${QueryOperator.Equal}${entity.paternityDocumentType.id}${QueryOperator.Split}`
        );
      }
      if (entity.rightholderStatus && entity.rightholderStatus.id) {
        query = query.concat(
          `rightholderStatus.id${QueryOperator.Equal}${entity.rightholderStatus.id}${QueryOperator.Split}`
        );
      }
      if (entity.country && entity.country.id) {
        query = query.concat(
          `country.id${QueryOperator.Equal}${entity.country.id}${QueryOperator.Split}`
        );
      }
      if (entity.rightholderDown && entity.rightholderDown.id) {
        query = query.concat(
          `rightholderDown.id${QueryOperator.Equal}${entity.rightholderDown.id}${QueryOperator.Split}`
        );
      }
      if (entity.eps && entity.eps.id) {
        query = query.concat(
          `eps.id${QueryOperator.Equal}${entity.eps.id}${QueryOperator.Split}`
        );
      }
      if (entity.epsPlan && entity.epsPlan.id) {
        query = query.concat(
          `epsPlan.id${QueryOperator.Equal}${entity.epsPlan.id}${QueryOperator.Split}`
        );
      }
      if (entity.maritalStatus && entity.maritalStatus.id) {
        query = query.concat(
          `maritalStatus.id${QueryOperator.Equal}${entity.maritalStatus.id}${QueryOperator.Split}`
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/employee-relative.service.ts